import { Modal, SpinnerIcon } from '@bp/ui-components';
import type { LicensedProductTypes } from 'pages/Settings/subpages/types';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { BigBlueButtonForm } from '../forms/BigBlueButtonForm';
import { BildungsplattformForm } from '../forms/BildungsplattformForm';
import { NextcloudForm } from '../forms/NextcloudForm';
import { ProcuratSettings } from '../forms/ProcuratSettings';
import { ThreemaBroadcastForm } from '../forms/ThreemaBroadcastForm';
import { ThreemaForm } from '../forms/ThreemaForm';

type BookingsModalProps = {
  bookingType: LicensedProductTypes;
  isOpen: boolean;
  onClose: () => void;
};

export const BookingsModal = ({ bookingType, isOpen, onClose }: BookingsModalProps) => {
  const { t } = useTranslation();

  const Form = () => {
    if (bookingType === 'Nextcloud')
      return (
        <Suspense fallback={<SpinnerIcon className={'svg-icon large spinning'} />}>
          <NextcloudForm onClose={onClose} />
        </Suspense>
      );
    else if (bookingType === 'BigBlueButton') return <BigBlueButtonForm onClose={onClose} />;
    else if (bookingType === 'Threema') return <ThreemaForm onClose={onClose} />;
    else if (bookingType === 'ThreemaBroadcast') return <ThreemaBroadcastForm onClose={onClose} />;
    else if (bookingType === 'Bildungsplattform') return <BildungsplattformForm onClose={onClose} />;
    else if (bookingType === 'Procurat!') return <ProcuratSettings onClose={onClose} />;
    // TODO: mailbox.org
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} title={`${t('settings.title')} ${bookingType}`}>
      {Form()}
    </Modal>
  );
};
